/*MIDDELWARE que une a los diferentes reducers creados*/
import sessionReducer from "./sessionReducer";
import openMessageReducer from "./openMessageReducer";
//une varios reducer y para que funcione hay que reflejarlo en el archivo index.js principal (reducer={mainReducer})
//cambia el estado de la sesion de cada reducer según su activacion
export const mainReducer = ({ sesion, openSnackbar }, action) => {
  return {
    sesion: sessionReducer(sesion, action),
    openSnackbar: openMessageReducer(openSnackbar, action)
  };
};
